import script from "./HeroCarouselItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroCarouselItem.vue?vue&type=script&setup=true&lang=js"

import "./HeroCarouselItem.vue?vue&type=style&index=0&id=fdcf7c88&lang=scss"

const __exports__ = script;

export default __exports__